import i18n from '../../../i18n';
import { resolveResponseLanguage } from '../../../services/contentTranslation';
import { normalizeDocumentLocale } from './documentLanguage';

/** Current UI locale — for chat chrome, workflow copy, and conversational agent replies. */
export function getAgentResponseLanguage(): string {
  return resolveResponseLanguage(i18n.language);
}

/** Document artifact locale — resume sections, cover letter, application note (JD-driven). */
export function getDocumentResponseLanguage(documentLocale?: string | null): string {
  return resolveResponseLanguage(normalizeDocumentLocale(documentLocale));
}
